<div class="d-flex p-2 row-gap-2 column-gap-4 flex-wrap">
  @if (selectedGuardUser?.id) {
  <dl>
    <div class="d-flex align-items-center gap-4">
      <div class="flex-grow-1">
        <dt>User</dt>
        <dd>{{ selectedGuardUser?.full_name }}</dd>
      </div>

      <span (click)="selectedGuardUser={}; shiftFocus('assigneeLookupFieldId')">
        <i class="fa-solid fa-circle-xmark text-danger fs-4"></i>
      </span>
    </div>
  </dl>

  @let contactNumber = selectedGuardUser?.user_add_info?.contact_number ||
  selectedGuardUser?.mobile_number; @if(contactNumber){
  <dl>
    <dt>Call</dt>
    <dd class="d-flex align-items-center">
      <div>
        <a
          href="tel:+{{ contactNumber }}"
          class="text-decoration-none text-success"
        >
          <i class="fa-solid fa-phone text-success"></i>
          <span class="fw-medium"> {{contactNumber}} </span>
        </a>
      </div>
    </dd>
  </dl>
  }

  <div class="form-floating">
    <input
      class="form-control input-font-sm"
      size="lg"
      placeholder="Pick Date Range "
      readonly
      [value]="dateRangeValue"
      (click)="openRangePicker()"
    />
    <label for="dateRange">Pick Date Range</label>
  </div>
  }@else {
  <gtapp-auto-complete
    [data]="assigneeListData"
    placeHolder="Selected User"
    searchKeyword="full_name"
    [itemTemplate]="assigneeTemplate"
    [initialValue]="selectedGuardUser?.full_name"
    (inputChanged)="onAssigneeSearch($event)"
    (selected)="onAssigneeSelect($event)"
    [enableCloseOption]="true"
    [inputId]="'assigneeLookupFieldId'"
  >
  </gtapp-auto-complete>
  <ng-template #assigneeTemplate let-item>
    <div class="d-flex gap-2 flex-wrap">
      <span> {{ item?.full_name }} </span>
      @if (item?.access_status === 2) {
      <div
        class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
      >
        Casual
      </div>
      }
    </div>

    @if (item?.subcontractors?.length) {
    <div class="small text-secondary">
      🟧Subcontractor:
      <span class="subcontractor-name">{{ item?.subcontractors }}</span>
    </div>
    }
  </ng-template>

  }
</div>

@if (selectedGuardUser?.id) {

<div class="user-stat-card-container p-2">
  <div class="col-12 col-md-auto">
    <gtapp-user-live-data
      [routedToPage]="false"
      [selectedUser]="selectedGuardUser"
    ></gtapp-user-live-data>
  </div>
  <div class="col-12 col-md-auto">
    <gtapp-user-live-jobs
      [selectedUser]="selectedGuardUser"
    ></gtapp-user-live-jobs>
  </div>
  @if( totalCountListDataCount?.length && userStatsCountList?.length &&
  totalCountListDataHours?.length && userStatsHoursList?.length){

  <div class="btn-group btn-group-lg mb-4" role="group">
    <button
      type="button"
      class="btn"
      (click)="showDataType='count'"
      [ngClass]="showDataType=='count'? 'btn-primary' : 'btn-outline-primary'"
    >
      Count
    </button>
    <button
      type="button"
      class="btn"
      (click)="showDataType='hours'"
      [ngClass]="showDataType=='hours' ? 'btn-primary' : 'btn-outline-primary'"
    >
      Hours
    </button>
  </div>
  } @if( totalCountListDataCount?.length && userStatsCountList?.length &&
  showDataType=='count'){
  <div class="user-stat-card col-12 col-md-auto">
    <dt class="mb-2">Count</dt>
    <table class="table table-small table-responsive table-striped">
      <tbody>
        @for (item of totalCountListDataCount; track $index) {
        <tr>
          <td>
            <div class="p-2">{{item?.label}}</div>
          </td>
          <td>
            <div class="p-2">{{item?.value}}</div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <div
    class="user-stat-card"
    [ngClass]="largeView?'':'col-12 col-md-auto overflow-45vh'"
  >
    <dt>Breakdown</dt>

    @if(largeView){
    <gtapp-gt-custom-table
      [deskTopTableData]="userStatsCountList"
      [desktopTableDetails]="tableDetailUserCount"
      [otherParams]="otherParamsUserStatData"
      [tableStyle]="{
       'overflow': 'auto',
       'max-height': '40vh',
        'max-width': '80vw'
      }"
    >
    </gtapp-gt-custom-table>

    }@else {

    <div class="d-flex gap-2 flex-column">
      @for(stat of userStatsCountList; track $index){
      <div class="card p-3">
        <div class="fw-bold text-center mb-2">
          {{stat?.date | customDate: 'd MMM y'}}
        </div>

        <div class="d-flex d-flex gap-2 flex-wrap mb-3">
          @for(item of userStatBreakDownKeysCount|misc:'getDictKeys' ; track
          $index){ @if(stat?.[item] > 0){
          <div>
            <span class="text-secondary small">
              {{userStatBreakDownKeysCount[item]}}:
            </span>

            <span> {{(stat?.[item])?.toFixed(0)}} </span>
          </div>

          } }
        </div>
      </div>

      }
    </div>
    }
  </div>
  } @if( totalCountListDataHours?.length && userStatsHoursList?.length &&
  showDataType=='hours'){
  <div class="user-stat-card col-12 col-md-auto">
    <dt class="mb-2">Hours</dt>
    <table class="table table-small table-responsive table-striped">
      <tbody>
        @for (item of totalCountListDataHours; track $index) {
        <tr>
          <td>
            <div class="p-2">{{item?.label}}</div>
          </td>
          <td>
            <div class="p-2">{{item?.value}}</div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <div
    class="user-stat-card"
    [ngClass]="largeView?'':'col-12 col-md-auto overflow-45vh'"
  >
    <dt>Breakdown</dt>

    @if(largeView){
    <gtapp-gt-custom-table
      [deskTopTableData]="userStatsHoursList"
      [desktopTableDetails]="tableDetailUserHours"
      [otherParams]="otherParamsUserStatData"
      [tableStyle]="{
        'overflow': 'auto',
       'max-height': '40vh',
        'max-width': '80vw'
      }"
    >
    </gtapp-gt-custom-table>

    }@else {
    <div class="d-flex gap-2 flex-column">
      @for(stat of userStatsHoursList; track $index){
      <div class="card p-3">
        <div class="fw-bold text-center mb-2">
          {{stat?.date | customDate: 'd MMM y'}}
        </div>

        <div class="d-flex d-flex gap-2 flex-wrap mb-3">
          @for(item of userStatBreakDownKeysHours|misc:'getDictKeys' ; track
          $index){ @if(stat?.[item] >0){
          <div>
            <span class="text-secondary small">
              {{userStatBreakDownKeysHours[item]}}:
            </span>

            <span> {{(stat?.[item])?.toFixed(0)}} </span>
          </div>

          } }
        </div>
        @if(clockedInOutTimes?.[stat?.date]){

        <span class="text-secondary small"> CLOCK IN-OUT </span>
        <div class="row row-cols-auto gap-1">
          @for(clockInOut of clockedInOutTimes?.[stat?.date]; track $index){
          <div class="p-1 rounded">
            <i class="fa-regular fa-clock"></i>
            {{clockInOut?.clocked_in| customDate: 'HH:mm'}}
            @if(clockInOut?.clocked_out){- @if((stat?.date| customDate: 'd MMM
            y') != (clockInOut?.clocked_out| customDate: 'd MMM
            y')){{{clockInOut?.clocked_out| customDate: 'd MMM y'}}}
            {{clockInOut?.clocked_out| customDate: 'HH:mm'}}}
          </div>

          }
        </div>
        }
      </div>

      }
    </div>
    }
  </div>
  }@if(completedTaskStats?.strokes){
  <div class="user-stat-card col-12 col-md-auto">
    <!--% runsheet completed https://stackblitz.com/edit/angular-circular-progress-using-components -->
    <dl class="text-center">
      <dt>Scheduled Patrols / Completed Tasks (%)</dt>

      <dd class="chart-container">
        <svg viewBox="0 0 36 36" class="circular-chart green">
          <!-- Background Circle -->
          <circle cx="18" cy="18" r="15.9155" class="circle-bg"></circle>

          <!-- Progress Circle -->
          <circle
            cx="18"
            cy="18"
            r="15.9155"
            class="circle"
            [attr.stroke-dasharray]="completedTaskStats?.strokes"
          ></circle>
        </svg>

        <!-- Overlay Text -->
        <div class="overlay-text">
          <div>{{ completedTaskStats?.percent }}%</div>
          <div class="small">
            {{ completedTaskStats?.sum_completed_tasks || 0 }} / {{
            completedTaskStats?.sum_total_tasks }}
          </div>
        </div>
      </dd>
    </dl>
  </div>
  } @if (dateRange?.start) {
  <div class="col-12 col-lg-8">
    <gtapp-user-trail
      [selectedUser]="selectedGuardUser"
      [dateRange]="dateRange"
    ></gtapp-user-trail>
  </div>
  }
</div>

}
